<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <textarea
    matInput
    cdkTextareaAutosize
    [placeholder]="placeholder"
    [ngModel]="text"
    (ngModelChange)="updateText($event)"
    (blur)="onBlur()"
    #autosize="cdkTextareaAutosize"
    cdkAutosizeMinRows="1"
    cdkAutosizeMaxRows="5"
  ></textarea>
  @if (hint) {
    <mat-hint class="hint">{{ hint }}</mat-hint>
  }
</mat-form-field>
